import { render, staticRenderFns } from "./ClientStatementReport.vue?vue&type=template&id=50e72ce4&"
import script from "./ClientStatementReport.vue?vue&type=script&lang=js&"
export * from "./ClientStatementReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports